export const themeGreen = {
	defaultFontStyle: { fontFamily: "https://fonts.googleapis.com/css?family=Roboto:300,400,400i,500,700" },
	palette: {
		themePrimary: "#269146",
		themeLighterAlt: "#f3fbf5",
		themeLighter: "#d1edda",
		themeLight: "#addebc",
		themeTertiary: "#69bd82",
		themeSecondary: "#379f56",
		themeDarkAlt: "#22833f",
		themeDark: "#1d6e35",
		themeDarker: "#155127",
		neutralLighterAlt: "#faf9f8",
		neutralLighter: "#f3f2f1",
		neutralLight: "#edebe9",
		neutralQuaternaryAlt: "#e1dfdd",
		neutralQuaternary: "#d0d0d0",
		neutralTertiaryAlt: "#c8c6c4",
		neutralTertiary: "#a19f9d",
		neutralSecondary: "#605e5c",
		neutralPrimaryAlt: "#3b3a39",
		neutralPrimary: "#323130",
		neutralDark: "#201f1e",
		black: "#000000",
		white: "#ffffff",
	},
};
